export type DeviceStatusKind = 'online' | 'offline' | 'never';

// The API words the status as 'Device online', 'Device offline' and 'Never Received'. The markers
// are tested in order because one text can contain another: offline holds online, and a status
// that says it was never online holds both.
const DEVICE_STATUS_MARKERS: [string, DeviceStatusKind][] = [
  ['never', 'never'],
  ['offline', 'offline'],
  ['online', 'online'],
];

export function deviceStatusKind(onlineStatus: string | null | undefined): DeviceStatusKind | null {
  const text = onlineStatus?.toLowerCase() ?? '';
  return DEVICE_STATUS_MARKERS.find(([marker]) => text.includes(marker))?.[1] ?? null;
}
